var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation } from '@apollo/client';
import { MUTATION } from './mutation';
export const useSetTaskAssignees = () => {
    const [mutation, { error, loading }] = useMutation(MUTATION);
    const setTaskAssignees = (assignees) => __awaiter(void 0, void 0, void 0, function* () {
        if (assignees.length === 0) {
            return;
        }
        yield mutation({
            variables: { objects: assignees },
            update: (cache, { data }) => {
                const [{ task_id: taskId }] = assignees;
                const { returning } = (data === null || data === void 0 ? void 0 : data.createTaskAssignee) || {};
                if (taskId && returning) {
                    const typename = 'Task';
                    const id = cache.identify({
                        __typename: typename,
                        id: taskId,
                    });
                    cache.modify({
                        id,
                        fields: {
                            assignees(existing = [], { toReference }) {
                                const newAssigneesRef = returning.map((assignee) => toReference(assignee, true));
                                return existing.concat(newAssigneesRef);
                            },
                        },
                    });
                }
            },
        });
    });
    return { setTaskAssignees, error, loading };
};
